import React, {
  memo,
  forwardRef,
  useState,
  useImperativeHandle,
  useCallback,
} from 'react';

import {
  Dialog,
  Slide,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Close } from '@material-ui/icons';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Transition = forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

const DialogFullScreen = forwardRef((props, ref) => {
  const { title, buttons, component: Component } = props;

  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [params, setParams] = useState({});

  const handleOpenModal = useCallback((data = {}) => {
    setOpen(true);
    setParams(data);
  }, []);

  const handleCloseModal = useCallback(() => {
    setOpen(false);
    setParams({});
  }, []);

  useImperativeHandle(ref, () => ({
    handleOpenModal,
    handleCloseModal,
  }));

  return (
    <Dialog
      fullScreen
      open={open}
      onClose={handleCloseModal}
      TransitionComponent={Transition}
    >
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseModal}
            aria-label="close"
          >
            <Close />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            {title}
          </Typography>
          {buttons.map((button) => (
            <Button
              key={Math.random()}
              autoFocus={!!button.autoFocus}
              color={button.color ?? 'inherit'}
              onClick={() => button.callback(params)}
            >
              {button.title}
            </Button>
          ))}
        </Toolbar>
      </AppBar>
      <Component {...params} open={open} close={handleCloseModal} />
    </Dialog>
  );
});

DialogFullScreen.propTypes = {
  title: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      autoFocus: PropTypes.bool,
      color: PropTypes.string,
      callback: PropTypes.func.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
};

DialogFullScreen.defaultProps = {
  title: '',
  buttons: [],
};

export default memo(DialogFullScreen);
